/**
 * @copyright Copyright 2019 The MathWorks, Inc.
 */

/**
 Used to add longpress support to the widget
 **/

define([
    "dojo/_base/declare"
], function (declare) {
    return declare(null, {
        buildRendering: function () {
            var that = this;
            this.inherited(arguments);
            this._longPressTimeout = null;
            this._longPressTriggered = false;
            this._activeEventListeners = [];
            this._eventListenersInfo = [
                {
                    target: this.domNode,
                    event: "touchstart",
                    callback: function (e) {
                        that._handleTouchStart(e)
                    }
                },
                {
                    target: document.body,
                    event: "touchend",
                    callback: this._handleTouchEnd.bind(this)
                },
                {
                    target: document.body,
                    event: "touchmove",
                    callback: this._clearLongPressTimeout.bind(this)
                },
                {
                    target: document.body,
                    event: "touchcancel",
                    callback: this._clearLongPressTimeout.bind(this)
                },
                {
                    target: document.body,
                    event: "mousedown",
                    callback: this._clearLongPressTimeout.bind(this)
                },
                {
                    target: document.body,
                    event: "mouseup",
                    callback: this._clearLongPressTimeout.bind(this)
                },
                {
                    target: document.body,
                    event: "mousewheel",
                    callback: this._clearLongPressTimeout.bind(this)
                },
                {
                    target: document.body,
                    event: "wheel",
                    callback: this._clearLongPressTimeout.bind(this)
                },
                {
                    target: window,
                    event: "blur",
                    callback: this._clearLongPressTimeout.bind(this)
                },
                {
                    target: window,
                    event: "resize",
                    callback: this._clearLongPressTimeout.bind(this)
                },
                {
                    target: document.body,
                    event: "contextmenu",
                    callback: this._contextMenuHandler.bind(this),
                    useCapture: true
                }
            ];
        },

        _emitCustomEvent: function(target, type, evtData) {
            if (window.CustomEvent) {
                if (!evtData.hasOwnProperty("bubbles")) {
                    evtData.bubbles = true;
                }
                if (!evtData.hasOwnProperty("cancelable")) {
                    evtData.cancelable = true;
                }
                if (!evtData.hasOwnProperty("composed")) {
                    evtData.composed = true;
                }
                target.dispatchEvent(new CustomEvent(type, evtData));
            } else {
                var ev = document.createEvent('CustomEvent');
                ev.initCustomEvent(type, true, true, evtData);
                target.dispatchEvent(ev);
            }
        },
    
        _handleTouchStart: function(e) {
            // Does not manage multi-touch
            var longPressHandler = function () {
                this._longPressTriggered = true;
                this._emitCustomEvent(e.target, "longpress", {detail:{x: e.changedTouches[0].pageX, y: e.changedTouches[0].pageY}});
            }.bind(this);
            
            this._longPressTimeout = setTimeout(longPressHandler, 500);
        },
    
        _handleTouchEnd: function(e) {
            // Prevent click event on a longpress
            if (this._longPressTriggered) {
                e.preventDefault();
            }
            this._clearLongPressTimeout();
        },
    
        _clearLongPressTimeout: function() {
            this._longPressTriggered = false;
            clearTimeout(this._longPressTimeout);
            this._longPressTimeout = null;
        },
    
        _contextMenuHandler: function(e) {
            // stop contextmenu event on a long press
            if (this._longPressTriggered) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        },

        _addTouchListeners: function () {
            if (this._activeEventListeners.length < this._eventListenersInfo.length) {
                for (var i = 0; i < this._eventListenersInfo.length; i++) {
                    this._eventListenersInfo[i].target.addEventListener(
                        this._eventListenersInfo[i].event,
                        this._eventListenersInfo[i].callback,
                        !!this._eventListenersInfo[i].useCapture);
                    this._activeEventListeners.push({
                        target: this._eventListenersInfo[i].target,
                        event: this._eventListenersInfo[i].event,
                        callback: this._eventListenersInfo[i].callback,
                        useCapture: !!this._eventListenersInfo[i].useCapture
                    });
                }
            }
        },

        _removeTouchListeners: function () {
            if (this._activeEventListeners.length > 0) {
                while(this._activeEventListeners.length > 0) {
                    var listener = this._activeEventListeners.pop();
                    listener.target.removeEventListener(
                        listener.event,
                        listener.callback,
                        !!listener.useCapture);
                }
            }
        },

        destroyRecursive: function () {
            this._removeTouchListeners();
            this.inherited(arguments);
        },

        destroy: function () {
            this._removeTouchListeners();
            this.inherited(arguments);
        }
    });
});
